import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface QasBatchStateChangedProps extends BaseTemplateProps {
  batchId: string
  state: string
  batchLink: string
}

export const QasBatchStateChanged: TemplateDefinition<QasBatchStateChangedProps> = {
  renderParams: (props: QasBatchStateChangedProps) => ({
    messageKey: 'notificationsDomain.templates.qasBatchStateChanged',
    values: {
      batchId: props.batchId,
      state: props.state,
    },
  }),
  getLink: (props: QasBatchStateChangedProps): string => props?.batchLink || '',
}
